import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';
import { useAppDispatch } from '../../../store';
import { BidStatus, IAuction, IProfile } from '../../../services';
import { ShowBidPanelAction } from '../../../store';
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-redeclare
import {Button, Icons} from '@sede-enterprise/shell-ds-react-framework'
import {
  ArrowRightIconAction,
  ButtonActionContainer,
  EditIconAction,
  NonButton,
  NonButtonActionContainer,
  ViewIconAction,
} from './BtnCellRenderer.styled';
import { FetchBookWithDocIdByDocIdAction } from '../../../store/Book/ActionCreator';
import { CheckForCreateBids } from '../../../helper/disabled-button';
import styled from 'styled-components';

export interface IBtnCellRendererProps extends ICellRendererParams {
  profilePage: IProfile;
}

const showIcon = (status: BidStatus, hasSubmitted?: boolean): string => {
  if (status === BidStatus.Draft || status === BidStatus.Rejected) {
    return 'arrow-point-right';
  } else if (
    status === BidStatus.Accepted || status === BidStatus.Amended ||
    (status === BidStatus.Closed && hasSubmitted)
  ) {
    return 'view';
  } else if (status === BidStatus.Closed && !hasSubmitted) {
    return 'cross';
  } else if (status === BidStatus.Open || status === BidStatus.Closing) {
    return 'edit';
  } else {
    return '';
  }
};

const showButton = (status: BidStatus, hasSubmitted?: boolean): boolean => {
  return !(status === BidStatus.Closed && !hasSubmitted);
};

const showText = (status: BidStatus, hasSubmitted?: boolean): string => {
  if (status === BidStatus.Draft || status === BidStatus.Rejected) {
    return 'Continue';
  } else if (
    status === BidStatus.Accepted || status === BidStatus.Amended ||
    (status === BidStatus.Closed && hasSubmitted)
  ) {
    return 'Show Capacity';
  } else if (status === BidStatus.Closed && !hasSubmitted) {
    return 'Not Submitted';
  } else if (status === BidStatus.Open || status === BidStatus.Closing) {
    return 'Create Bids';
  } else {
    return '';
  }
};

const CrossIconAction = styled(Icons.Cross)`
  width: 20px;
  height: 20px;
`;

const CellWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  line-height: normal;
`;

const StyledButton = styled(Button)`
  && {
    min-height: unset;
    padding: 0;
    margin-top: 3px;
  }
`;

const BtnCellRenderer: React.FC<IBtnCellRendererProps> = (
  props: IBtnCellRendererProps
) => {
  const dispatch = useAppDispatch();
  const auctionRecord = props.data as IAuction;
  const { profilePage } = props;

  var res = showIcon(
    auctionRecord?.bidStatus as BidStatus,
    auctionRecord?.hasSuccessfullyBid
  );

  return (
    <CellWrapper>
      <ButtonActionContainer className='button-action' data-testid='BtnCellRenderer'>
        {showButton(
          auctionRecord?.bidStatus as BidStatus,
          auctionRecord?.hasSuccessfullyBid
        ) ? (
          <StyledButton
            className="shell-button-renderer"
            size='small'
            disabled={
              CheckForCreateBids(profilePage) &&
                (auctionRecord?.bidStatus === BidStatus.Open ||
                  auctionRecord?.bidStatus === BidStatus.Closing ||
                  auctionRecord?.bidStatus === BidStatus.Draft)
              }  
            onClick={() => {
              dispatch(ShowBidPanelAction(auctionRecord));
              dispatch(
                
                FetchBookWithDocIdByDocIdAction(auctionRecord.identification)
              );
            }}
            icon={res === "edit" ? <Icons.Edit/> : (res === "view" ? <Icons.EyeHollow/> : 
            (res === "cross" ? <CrossIconAction/> : (res === "arrow-point-right" ? <Icons.ArrowRight/> : <></>))) }
          > 
              <span>{showText(
              auctionRecord?.bidStatus as BidStatus,
              auctionRecord?.hasSuccessfullyBid
            )}</span>
          </StyledButton>
        ) : (
          <NonButtonActionContainer>
            {
            res === "arrow-point-right" ? 
                <ArrowRightIconAction/> : (res === "edit" ? <EditIconAction/> : 
                (res === "view" ? <ViewIconAction/> : (res === "cross" ? 
                <CrossIconAction color='red' /> : <></>)))

            }
            <NonButton>
              {showText(auctionRecord?.bidStatus as BidStatus)}
            </NonButton>
          </NonButtonActionContainer>
        )}
      </ButtonActionContainer>
    </CellWrapper>
  );
};
export default BtnCellRenderer;
